import { useTranslation } from 'react-i18next';

export default function AboutMission() {
  const { t } = useTranslation('about');

  return (
    <section className="py-16 md:py-24 bg-white">
      <div className="w-full px-6 md:px-10 lg:px-16">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          <div className="relative">
            <div className="rounded-2xl overflow-hidden shadow-lg">
              <img
                src="https://readdy.ai/api/search-image?query=elegant%20close-up%20photograph%20of%20a%20musician%20playing%20acoustic%20guitar%20on%20a%20warmly%20lit%20stage%20with%20golden%20hour%20lighting%2C%20amber%20and%20warm%20tones%2C%20professional%20concert%20photography%2C%20shallow%20depth%20of%20field%2C%20intimate%20atmosphere&width=800&height=600&seq=about-mission&orientation=landscape"
                alt="Musician"
                className="w-full h-[300px] md:h-[400px] object-cover"
              />
            </div>
          </div>
          <div>
            <span className="inline-block text-xs md:text-sm font-semibold text-amber-600 uppercase tracking-widest mb-4">
              {t('missionLabel')}
            </span>
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900 leading-tight mb-6">
              {t('missionTitle')}
            </h2>
            <p className="text-base md:text-lg text-gray-600 leading-relaxed mb-4">
              {t('missionDescription')}
            </p>
            <p className="text-base md:text-lg text-gray-600 leading-relaxed">
              {t('missionDescription2')}
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}